export default __webpack_public_path__ + "static/media/Dr_Janos_Elek.7c3f4248.jpg";